module.exports = "<h1 style=\"margin-top: 8rem\">recomendations</h1>";


/*****************
 ** WEBPACK FOOTER
 ** ./client/public/main/recomendations/recomendations.html
 ** module id = 212
 ** module chunks = 0
 **/